import React, { FunctionComponent, ReactElement, memo, useMemo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import ButtonFont from '../../../../Theme/Fonts/Button'
import { getFontColorByBackgroundColor } from '../../../../utils/Colors'
import { ButtonTypes } from '../ButtonTypes'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import LinkProps from '../../../../Link/LinkProps'
import { FixedMarginProps } from '../../../../utils/styling/StylingHelper'

type BasicButtonProps = {
    children: string
    href?: string
    onPress?: () => void
    expand?: boolean
    paddingX?: number
    paddingY?: number
    height?: number | string
    borderRadius?: number
    bold?: boolean
    uppercase?: boolean
    iconName?: 'play-active'
} & ButtonTypes &
    LinkProps &
    FixedMarginProps &
    TestID

const BasicButton: FunctionComponent<BasicButtonProps> = ({
    children,
    backgroundColor = 'pearl',
    href,
    onPress,
    expand = false,
    paddingX,
    paddingY,
    height,
    borderRadius = 3,
    bold = true,
    uppercase = true,
    iconName,
    testID,
    webRel,
    ...rest
}): ReactElement => {
    const buttonFont = useMemo(() => {
        return (
            <ButtonFont
                color={getFontColorByBackgroundColor(backgroundColor)}
                bold={bold}
                uppercase={uppercase}
            >
                {children}
            </ButtonFont>
        )
    }, [bold, children, backgroundColor, uppercase])
    return (
        <Grid horizontal={!expand} noExpand testID={testID} {...rest}>
            <Touchable onPress={onPress} href={href} webRel={webRel}>
                <Grid
                    backgroundColor={backgroundColor}
                    paddingX={paddingX}
                    paddingY={paddingY}
                    borderRadius={borderRadius}
                    noExpand
                    height={height}
                    centerVertical
                >
                    {iconName ? (
                        <Grid noExpand horizontal>
                            <Grid marginRight={4} noExpand>
                                <FontelloIcon
                                    name={iconName}
                                    color={getFontColorByBackgroundColor(backgroundColor)}
                                />
                            </Grid>
                            {buttonFont}
                        </Grid>
                    ) : (
                        buttonFont
                    )}
                </Grid>
            </Touchable>
        </Grid>
    )
}

export default memo(BasicButton)
